//
//
//
//
//
//

import { generateComputed } from '../../../../common/functions/roles-computed-generator';

export default {
  name: 'Usuario',
  methods: {
    accessForbidden() {
      this.$router.push({ name: 'inicio' });
      this.$toast.create('Acesso negado', 'snack', 3E3);
    },
  },
  computed: {
    ...generateComputed('usr', [
      'canAccessPage',
    ]),
  },
  beforeMount() {
    if (!this.canAccessPage) {
      window.setTimeout(() => this.accessForbidden(), 1E3);
    }
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/usuario/Usuario.vue?vue&type=script&lang=js&